import React from 'react';
import './AboutConference27.css';
import Navbar from '../../components/navbar';
import PageHeader from '../../about/PageHeader';
import Footer from '../../components/Footer';

const AboutConference27 = () => {
  return (
     <>
      <Navbar />
      <PageHeader
        title="About Conference"
        crumbs={[
          { label: "Home", href: "/" },
          { label: "About Conference" },
        ]}
      />
    <div className="icaim-page-container">

      <div className="icaim-content-wrapper">
        
        {/* Intro Text Card */}
        <div className="icaim-card icaim-intro-card">
          <p>In an intensely connected world, where information is barely a click away, the importance of ignorance being a bliss has no standing. With an ocean of information, ideally the world should be empowered enough to have nil existence of any sort of negativity. However, the facts are different. Today every individual needs support to prove their existence. Every individual needs Empowerment.</p>
          <p>Empowerment is the level of independence bestowed on an individual or community which enables them to exhibit their interests and become stronger and confident to take charge of their rights freely and responsibly. An empowered nation is a representation of empowered individuals in that nation.</p>
          <p>The global statistics claims that the ratio of men to women is literally 1:1. However, this ratio does not reflect the empowerment aspect. Even today women are considered unequal to men. Whether it is job front or the home front, women are deprived. There is evident need for improvement in social, political, health, financial and educational status of women. There is need for Women Empowerment.</p>
          <p>Women are an integral part of every domain, including healthcare and agriculture. There are several women who have made history in general and in healthcare and agriculture domains in specific. Yet, there are cases where large population of women and children are deprived of basic nutritional and health facilities.</p>
          <p>It is time that Women should be given equal status and empowered to build nations that converge into a world filled with positivity and prosperity.</p>
          <p>Information Technology (IT) will play a pivotal role to empower women. ICAIM 2024 focuses on the leverage of IT for empowering Women across every stratum.</p>
        </div>

        {/* Objectives Section */}
        <section className="icaim-section">
          <div className="icaim-section-header">
            <div className="icaim-icon-box">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="icaim-svg-icon">
                <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 3.75H6A2.25 2.25 0 003.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0120.25 6v1.5m0 9V18A2.25 2.25 0 0118 20.25h-1.5m-9 0H6A2.25 2.25 0 013.75 18v-1.5M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <h2>Objectives</h2>
          </div>
          
          <div className="icaim-card icaim-objectives-card">
            <div className="icaim-objective-item">
              <span className="icaim-num-badge">1</span>
              <p>Awareness of the importance of sustainable Women Empowerment (WE).</p>
            </div>
            <div className="icaim-objective-item">
              <span className="icaim-num-badge">2</span>
              <p>Engage discussion and deliberations with professionals from various sectors in general and Agriculture, Healthcare, and IT in specific on Women Empowerment.</p>
            </div>
            <div className="icaim-objective-item">
              <span className="icaim-num-badge">3</span>
              <p>Study the leverage of Information Technology for empowering Women.</p>
            </div>
            <div className="icaim-objective-item">
              <span className="icaim-num-badge">4</span>
              <p>Innovate and research sustainable methods to support Women Empowerment.</p>
            </div>
          </div>
        </section>

        {/* Sub Themes Section */}
        <section className="icaim-section">
          <div className="icaim-section-header">
            <div className="icaim-icon-box">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="icaim-svg-icon">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 6.878V6a2.25 2.25 0 012.25-2.25h7.5A2.25 2.25 0 0118 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 004.5 9v.878m13.5-3A2.25 2.25 0 0119.5 9v.878m0 0a2.246 2.246 0 00-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0121 12v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6c0-.98.626-1.813 1.5-2.122" />
              </svg>
            </div>
            <h2>Sub Themes</h2>
          </div>
          
          <div className="icaim-themes-grid">
            {/* Agriculture Box */}
            <div className="icaim-card icaim-theme-box">
              <div className="icaim-theme-header">
                <h3>Agriculture:</h3>
              </div>
              <ul className="icaim-bullet-list">
                <li>Government Schemes in Agriculture for Sustainable WE.</li>
                <li>New technologies in agriculture focusing WE</li>
                <li>WE for promoting Agricultural Economy.</li>
                <li>Financial Empowerment for Women.</li>
                <li>Literacy Empowerment for Women.</li>
                <li>Government Health schemes for WE in villages.</li>
              </ul>
            </div>

            {/* Medicine Box */}
            <div className="icaim-card icaim-theme-box">
              <div className="icaim-theme-header">
                <h3>Medicine:</h3>
              </div>
              <ul className="icaim-bullet-list">
                <li>WE through improved Health index</li>
                <li>Health Information Systems to support WE.</li>
                <li>Innovation in Healthcare to boost WE</li>
                <li>Government Health Policies for WE</li>
                <li>Effect of Modern Lifestyle on Women's Health</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Role of IT Section */}
        <section className="icaim-section">
          <div className="icaim-section-header">
            <div className="icaim-icon-box">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="icaim-svg-icon">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25" />
              </svg>
            </div>
            <h2>Role of IT for Empowering Todays Women – Nari Shakti</h2>
          </div>

          <div className="icaim-card icaim-it-box">
            <div className="icaim-it-header">
              General - Women Empowerment focussing on
            </div>
            <div className="icaim-it-content">
              <ul className="icaim-bullet-list">
                <li>Roles and Challenges</li>
                <li>Societal Expectations</li>
                <li>Financial Inclusion</li>
                <li>Women and Technology</li>
                <li>Innovative Technology for WE</li>
                <li>Sustainability in WE</li>
                <li>Climate Change, Migration and Women Empowerment</li>
                <li>Education and Employment for WE</li>
                <li>Economic Growth and Gender Equity</li>
                <li>Legal Reforms for WE</li>
                <li>Cross-Culture reforms for WE</li>
                <li>He for She</li>
                <li>Breaking Gender Stereotypes</li>
              </ul>
            </div>
          </div>

          {/* Footer Note */}
          <div className="icaim-footer-note">
            <p><em>Any other topics in line with the theme of the Conference.</em></p>
          </div>
        </section>

      </div>
    </div>
        <Footer />
    </>
  );
};

export default AboutConference27;